/// <reference path="../typings.d.ts" />
import { OnInit, Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppTitle } from './title';
import { OneRosterService } from './oneroster.service';
import { Alert } from './alert';
import { Registration } from './registration';
import { User } from './user';
import { validateToken } from './account.service';
import { RegistrationFind } from './registration_find';
import { isDateSet, dateFormat } from './date_helper';

@Component({
	selector: 'registration',
	styles: [`
        .tag {
            margin-right:2px;
            background-color:#9dbd9e;
            border-radius:4px;
            padding:5px;
        }
        .tag-close {
            margin-left:5px;
            cursor: pointer;
        }
    `],
	template: `
        <div class="row" [hidden]="msgHead.msg == ''">
            <div class="col-lg-8 col-md-6 col-xs-12">
                <alert [alert]="msgHead"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-6 col-md-6 col-xs-12">
                <alert [alert]="msg" style="display:block;"></alert>
            </div>
        </div>
        <div *ngIf="hasAccess" class="row">
            <div class="col-lg-8 col-md-7 col-xs-12">
                <button type="button" class="btn btn-large btn-primary" (click)="addRegistration()">Add New</button>
                <button type="button" class="btn btn-large btn-deny" style="margin-left:5px;" (click)="refresh()">Refresh</button>
            </div>
		    <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="card">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Base URL</th>
								<th>Version</th>
                                <th>Client ID</th>
                                <th>Sync Status</th>
                                <th>Sync Enabled</th>
                                <th>Changed At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of data; let i = index">
                                <td style="width:15%;">{{ row.oneRosterApiUrl }}</td>
								<td style="width:15%;">{{ row.oneRosterApiVersion }}</td>
                                <td style="width:15%;">{{ row.oauthClientId }}</td>
                                <td style="width:10%;">{{ row.syncStatus }}</td>
                                <td style="width:10%;">{{ row.syncEnabled ? 'Yes' : 'No' }}</td>
                                <td style="width:25%;">{{ printDate(row.updatedAt) ? printDate(row.updatedAt) : printDate(row.createdAt) }}</td>
                                <td style="width:25%;">
                                    <span title="Edit" class="btn-link" style="cursor: pointer;" (click)="edit(row)">Edit</span> |
                                    <span title="Sync" class="btn-link" style="cursor: pointer;" (click)="sync(row)">Sync</span> |
                                    <span title="School Mapping" class="btn-link" style="cursor: pointer;" (click)="schoolMapping(row)">School Mapping</span> |
                                    <span title="Remove User" class="glyphicon glyphicon-trash" aria-hidden="true" (click)="removeRegistration(row)"></span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `
})

export class RegistrationComponent implements OnInit {
	data: Registration[];
	msg: Alert;
	msgHead: Alert;
	acctNumber: string;
	hasAccess: boolean;
	maxPageSize: number;
	// user: User;

	constructor(private router: Router, private orvc: OneRosterService, private title: AppTitle, private activatedRoute: ActivatedRoute) {
		this.hasAccess = true;
		this.msg = new Alert();
		this.msgHead = new Alert();
		title.setTitles({
			title: 'Registrations',
			dashboard: 'Registrations'
		});
		this.title.setBreadcrumbs([
			{ title: 'Registrations', link: `` }
		]);
		this.data = [];
	}

	ngOnInit() {
		this.acctNumber = this.activatedRoute.snapshot.params['acctNumber'];
		if (this.acctNumber != null) {
			this.orvc.validateAcctNumber(this.acctNumber)
				.subscribe(res => {
					if (!res) {
						this.msgHead.error(`You don't have access to this district number ${this.acctNumber}`);
						this.hasAccess = false;
					}
				}, err => {
					console.log(err);
					let e = this.orvc.getUserErrorDefault(err);
					this.msgHead.error(e);
					this.hasAccess = false;
				})
		}
		this.loadData();
	}

	loadData() {
		let f = new RegistrationFind();
		this.orvc.registrationFindApi(this.acctNumber, f).subscribe((regs: Registration[]) => {
			this.data = regs;
			this.msg.close();
		}, err => {
			console.log(err);
			if (this.orvc.isErrNotFound(err)) {
				this.msg.warning(this.orvc.getUserError(err));
			} else {
				if (this.orvc.isErrUnauthorized(err)) {
					this.hasAccess = false;
					this.msgHead.error(this.orvc.getUserErrorDefault(err));
				} else {
					this.msg.error(this.orvc.getUserErrorDefault(err));
				}
			}
		});
	}

	refresh() {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		this.loadData();
		this.msg.close();
	}

	addRegistration() {
		this.router.navigate([`settings/${this.acctNumber}/registrations/add`]);
		return;
	}

	edit(reg: Registration) {
		this.router.navigate([`settings/${this.acctNumber}/registrations/${reg.id}/edit`]);
		return;
	}

	sync(reg: Registration) {
		this.router.navigate([`settings/${this.acctNumber}/registrations/${reg.id}/sync`]);
		return;
	}

	schoolMapping(reg: Registration) {
		this.router.navigate([`settings/${this.acctNumber}/registrations/${reg.id}/school-mapping`]);
		return;
	}

	removeRegistration(reg: Registration) {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		this.orvc.registrationRemoveApi(this.acctNumber, reg.id)
			.subscribe(res => {
				this.data.splice(this.data.indexOf(reg), 1);
			}, err => {
				console.log(err);
				let e = this.orvc.getUserErrorDefault(err);
				this.msgHead.error(e);
			});
	}

	printDate(d: Date): string {
		let df = '01/02/2006 03:04 PM';
		if (isDateSet(d)) {
			return dateFormat(d, df);
		}
		return '';
	}
}
